import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LoginComponent from '../components/LoginComponent';
import action from '../redux/actions/login';

const mapStateToProps = (state) => ({
  login: state.login,
});

const mapDispatchToProps = (dispatch) => ({
  onLoginQR1Action: (params) => {
    dispatch(action.loginQR1(params));
  },
  onLoginQR2Action: (params) => {
		  dispatch(action.loginQR2(params));
  },
  onLoginQR3Action: (params) => {
    dispatch(action.loginQR3(params));
  },
  onLoginNormal: (params) => {
    dispatch(action.loginNormal(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent));
